/* Uncomment line below if you need jQuery */
import $ from "jquery";

export const numberPicker = () => {
    $(".js-numberpicker").each(function () {
        const $floater = $(this).find(".numberPicker__float");
        const min = $(this).data("np-min");
        const max = $(this).data("np-max");
        const $label = $(this).find(".js-numberpicker-label");
        const dataPicker = $(this).data("picker");
        for (let i = min; i <= max; i++) {
            $floater.append(
                '<span class="js-numpick-val" data-val="' +
                    i +
                    '" data-picker="' +
                    dataPicker +
                    '">' +
                    i +
                    "</span>",
            );
        }

        $label.on("click", function () {
            const isOpen = $floater.hasClass("is-open");
            $floater.toggleClass("is-open", !isOpen);
        });
    });

    $(document).on("click", ".js-numpick-val", function () {
        const $picker = $(this).parents(".js-numberpicker");
        const $label = $picker.find(".js-numberpicker-label");
        const valString = $(this).data("val");
        const dataPicker = $(this).data("picker");
        const val = parseInt(valString);

        if (val < 10) {
            $label.text("0" + valString);
            $("#" + dataPicker + "Val").val("0" + valString);
        } else {
            $label.text(valString);
            $("#" + dataPicker + "Val").val(valString);
        }

        $(this).siblings().removeClass("is-selected");
        $(this).addClass("is-selected");

        $(this).parent().removeClass("is-open");

        const inputStats = validateForm();

        if (inputStats) {
            $(".js-submit-date").prop("disabled", false);
        }
    });

    function validateForm() {
        var isValid = true;
        $(".js-picker-field").each(function () {
            if ($(this).val() === "") isValid = false;
        });
        return isValid;
    }
};
